import getTempUserShortId from '../utils/getTempUserId'
import React, { useEffect, useState } from 'react'
import { baseURL } from '../../utils/baseURL'
import { fbAppId } from '../../utils/fbAppId'
import { checkEmail, checkName, checkPassword } from '../Login'
import styles from '../styles/Login.module.css'
import { useAuth } from '../hooks/useAuth'
import { useGoogleLogin } from '@react-oauth/google'
import { UserDTO } from '../Types/dto/user'
import env from '../configs/env'

export default function Login({
	platform,
	completion,
	createTeamIfNotExist,
	isWordpressAdmin,
	resetToken,
}: {
	completion: (userDTO?: UserDTO) => void
	platform: string
	createTeamIfNotExist?: Boolean
	isWordpressAdmin?: Boolean
	resetToken?: string
}) {
	const auth = useAuth()
	const [isRegistration, setIsRegistration] = useState(true)
	const [isForgotPass, setIsForgotPass] = useState(false)
	const [email, setEmail] = useState<string>('')
	const [name, setName] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [passwordConfirmation, setPasswordConfirmation] = useState<string>('')
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		// Check if the router is ready (assuming it's ready when the pathname is not '/')
		if (window.location.pathname !== '/') {
			setLoading(false)
		}
	}, [])

	const login = useGoogleLogin({
		onSuccess: (tokenResponse) => {
			console.log(tokenResponse)
			auth.handleAuth(
				baseURL(env, platform == 'next') + 'registerGoogleUser',
				{
					tempUserShortId: getTempUserShortId(),
					access_token: tokenResponse.access_token,
				},
				completion
			)
		},
	})

	useEffect(() => {
		if (platform == 'wordpress') {
			window.fbAsyncInit = function () {
				window.FB.init({
					appId: fbAppId(env),
					cookie: true,
					xfbml: true,
					version: 'v14.0',
				})
				window.FB.AppEvents.logPageView()
				if (
					navigator.userAgent.indexOf('FBAN') != -1 ||
					navigator.userAgent.indexOf('FBAV') != -1
				) {
				}
			}
			;(function (d, s, id) {
				var js,
					fjs = d.getElementsByTagName(s)[0]
				if (d.getElementById(id)) {
					return
				}
				js = (d.createElement(s) as HTMLImageElement) || null
				js.id = id
				js.src = 'https://connect.facebook.net/en_US/sdk.js'
				fjs.parentNode?.insertBefore(js, fjs)
			})(document, 'script', 'facebook-jssdk')
		}
	}, [])

	useEffect(() => {
		if (localStorage.getItem('isLoggedOut')) {
			setIsRegistration(false)
		}
	}, [])

	return loading ? (
		<></>
	) : (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '1rem',
				background: 'white',
				padding: '30px',
				borderRadius: '10px',
				alignSelf: 'center',
			}}
		>
			{platform == 'next' && !resetToken && (
				<>
					<button
						className={`${styles.button} ${styles.facebookBtn}`}
						onClick={() => {
							const element = document.activeElement as HTMLElement
							element.blur()
							if (!window.FB) {
								return
							}
							window.FB.login(function (res: any) {
								window.FB.api(
									res.authResponse?.userID,
									{ fields: 'id,name,picture' },
									function (res2: any) {
										if (res.authResponse.accessToken === undefined) {
											return
										}

										auth.handleAuth(
											baseURL(env, platform == 'next') + 'registerFacebookUser',
											{
												accessToken: res.authResponse.accessToken,
												photoUrl: res2.picture.data.url,
												tempUserShortId: getTempUserShortId(),
												userName: res2.name,
												appId: fbAppId(env),
											},
											completion
										)
									}
								)
							})
						}}
					>
						Facebook bejelentkezés
					</button>
					<button
						className={`${styles.button} ${styles.googleBtn}`}
						onClick={() => login()}
					>
						Google bejelentkezés
					</button>
					<hr className="space-sm" />
				</>
			)}
			{!resetToken && (
				<input
					className={'input-text'}
					value={email}
					placeholder="E-mail"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setEmail(e.target.value)
					}
					autoComplete="email"
					style={{ margin: 0 }}
					name="email"
					type="text"
				/>
			)}
			{isRegistration && !resetToken && (
				<input
					className={'input-text'}
					value={name ?? ''}
					placeholder="Név"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setName(e.target.value)
					}
					autoComplete="name"
					style={{ margin: 0 }}
					name="name"
					type="text"
				/>
			)}
			{!isForgotPass && (
				<input
					className={'input-text'}
					value={password ?? ''}
					type="password"
					placeholder="Jelszó"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setPassword(e.target.value)
					}
					autoComplete={
						isWordpressAdmin == true
							? 'off'
							: isRegistration
							? 'new-password'
							: 'current-password'
					}
					style={{ margin: 0 }}
					name="password"
				/>
			)}
			{(isRegistration || resetToken) && (
				<input
					className={'input-text'}
					value={passwordConfirmation ?? ''}
					type="password"
					placeholder="Jelszó újra"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setPasswordConfirmation(e.target.value)
					}
					autoComplete={
						isWordpressAdmin == true
							? 'off'
							: isRegistration
							? 'new-password'
							: 'current-password'
					}
					style={{ margin: 0 }}
					name="passwordConfirm"
				/>
			)}
			{!isForgotPass && !resetToken && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						const element = document.activeElement as HTMLElement
						element.blur()
						if (!checkEmail(email) || !checkPassword(password)) {
							return
						}
						if (isRegistration) {
							if (email?.includes('freemail.hu')) {
								alert(
									'Amennyiben freemail-es e-maillel próbálsz bejelentkezni, abban az esetben kérjük használj másikat. A rendszer a freemail.hu-t nem támogatja.'
								)
								return
							}
							if (!checkName(name)) {
								return
							}
							auth.handleAuth(
								'auth/registerEmail',
								{
									name: name,
									email: email,
									password: password,
								},
								completion
							)
						} else {
							auth.handleAuth(
								'auth/loginEmail',
								{
									email: email,
									password: password,
								},
								completion
							)
						}
					}}
					data-cy="login"
				>
					{isRegistration ? 'Regisztáció' : 'Bejelentkezés'}
				</button>
			)}
			{isForgotPass && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						const element = document.activeElement as HTMLElement
						element.blur()
						if (!checkEmail(email)) {
							return
						}
						auth.handleAuth(
							'sendResetPassword',
							{
								email: email,
							},
							completion
						)
					}}
				>
					Új jelszó
				</button>
			)}
			{resetToken && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						auth.handleAuth(
							'auth/resetPassword',
							{
								password,
								resetToken,
							},
							completion
						)
					}}
				>
					Módosítom
				</button>
			)}
			{!resetToken && (
				<div>
					{!isRegistration ? (
						<div className={styles.div1}>
							Nincs még fiókod?{' '}
							<a
								className={styles.link}
								onClick={() => {
									setIsRegistration(true)
									setIsForgotPass(false)
								}}
							>
								Regisztrálj a Tikex-re
							</a>
						</div>
					) : (
						<div className={styles.div1}>
							Már regisztráltál?{' '}
							<a
								className={styles.link}
								onClick={() => {
									setIsRegistration(false)
									setIsForgotPass(false)
								}}
							>
								Bejelentkezés
							</a>
						</div>
					)}
					{!isForgotPass && (
						<div className={styles.div1}>
							<a
								className={styles.link}
								onClick={() => {
									setIsRegistration(false)
									setIsForgotPass(true)
								}}
							>
								Elfelejtetted a jelszavad?
							</a>
						</div>
					)}
				</div>
			)}
		</div>
	)
}
